module.exports = __webpack_public_path__ + "src/assets/img/share/tips/conscientiousness/e1596c18bfc5fc868bf6dcb51a792e7e.png";